import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "ss-tela-estrutura" }
const _hoisted_2 = { class: "ant-row" }
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_4 = { class: "ant-btn-group ss-grupo-recursos" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "Nova", -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  style: {"height":"calc(100% - 60px)"},
  class: "ss-card ss-card-space ss-tela-conteudo-completo"
}
const _hoisted_8 = { class: "ant-row" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-selecionar-empresas" }, "EMPRESA:")
], -1)
const _hoisted_10 = { class: "ant-col ant-col-xs-24 ant-col-xl-13" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-selecionar-empresas" }, "PERÍODO:")
], -1)
const _hoisted_12 = { class: "ant-col ant-col-xs-24 ant-col-xl-5" }
const _hoisted_13 = {
  key: 0,
  class: "ant-row"
}
const _hoisted_14 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_titulo_padrao = _resolveComponent("titulo-padrao")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_selecionar_filtro_periodo_movimento_comercial = _resolveComponent("selecionar-filtro-periodo-movimento-comercial")!
  const _component_selecionar_data_inicial_final = _resolveComponent("selecionar-data-inicial-final")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_busca_geral = _resolveComponent("busca-geral")!
  const _component_card = _resolveComponent("card")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_kanban = _resolveComponent("kanban")!
  const _component_processo_producao_listagem = _resolveComponent("processo-producao-listagem")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_ordem_producao_modal = _resolveComponent("ordem-producao-modal")!
  const _component_etapa_processo_producao_modal = _resolveComponent("etapa-processo-producao-modal")!
  const _component_preview_pdf = _resolveComponent("preview-pdf")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_titulo_padrao, {
          identificadorRecurso: 'PROCESSO-PRODUCAO',
          tituloRecurso: _ctx.state.tituloRecurso,
          exibirAtalhosTela: false,
          exibirHistoricoTela: true,
          empresasSelecionadas: [_ctx.state.empresaSelecionada]
        }, {
          BotoesAcoes: _withCtx(() => [
            _createElementVNode("div", {
              class: "ss-principais-acoes",
              style: _normalizeStyle(_ctx.storeSistema.state.layoutMobile ? 'margin-left: auto; margin-right: auto;' : '')
            }, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("button", {
                  type: "button",
                  style: {"width":"150px"},
                  class: "ant-btn ant-btn-primary ss-btn-tela",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.incluirOp && _ctx.incluirOp(...args)))
                }, _hoisted_6)
              ])
            ], 4)
          ]),
          _: 1
        }, 8, ["tituloRecurso", "empresasSelecionadas"]),
        _createVNode(_component_a_spin, {
          spinning: _ctx.state.carregandoTela,
          size: "large"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_card, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(_component_a_select, {
                        value: _ctx.state.empresaSelecionada,
                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.empresaSelecionada) = $event)),
                        options: _ctx.telaBase.empresasDisponiveis,
                        style: {"width":"100%"},
                        optionFilterProp: "label",
                        onChange: _ctx.atualizarSelecaoEmpresas,
                        disabled: true
                      }, null, 8, ["value", "options", "onChange"])
                    ]),
                    _hoisted_11,
                    _createElementVNode("div", _hoisted_12, [
                      _createVNode(_component_selecionar_filtro_periodo_movimento_comercial, {
                        valor: _ctx.state.filtroPeriodo,
                        "onUpdate:valor": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.filtroPeriodo) = $event)),
                        onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.periodoAlterado()))
                      }, null, 8, ["valor"]),
                      ((_ctx.state.filtroPeriodo === _ctx.EFiltroPeriodoMovimentoComercial.Personalizado))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                            _createElementVNode("div", _hoisted_14, [
                              _createVNode(_component_a_form_item, {
                                label: "Data Inicial e Final",
                                class: "ss-margin-campos"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_selecionar_data_inicial_final, {
                                    dataInicialSelecionada: _ctx.state.dataInicialSelecionada,
                                    "onUpdate:dataInicialSelecionada": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.dataInicialSelecionada) = $event)),
                                    dataFinalSelecionada: _ctx.state.dataFinalSelecionada,
                                    "onUpdate:dataFinalSelecionada": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.dataFinalSelecionada) = $event)),
                                    onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.buscarOps()))
                                  }, null, 8, ["dataInicialSelecionada", "dataFinalSelecionada"])
                                ]),
                                _: 1
                              })
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createVNode(_component_busca_geral, {
                    empresas: [_ctx.state.empresaSelecionada],
                    ordenacao: _ctx.telaBase.ordenacaoSelecionada,
                    "onUpdate:ordenacao": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.telaBase.ordenacaoSelecionada) = $event)),
                    buscaRapida: _ctx.state.buscaRapida,
                    "onUpdate:buscaRapida": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.buscaRapida) = $event)),
                    buscaAvancada: _ctx.state.buscaAvancada,
                    "onUpdate:buscaAvancada": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.buscaAvancada) = $event)),
                    onBuscarDados: _ctx.buscarOps
                  }, null, 8, ["empresas", "ordenacao", "buscaRapida", "buscaAvancada", "onBuscarDados"])
                ]),
                _: 1
              }),
              _createVNode(_component_card, { style: {"height":"calc(100vh - 225px)","margin-bottom":"0px"} }, {
                default: _withCtx(() => [
                  (_ctx.state.visualizarKanban)
                    ? (_openBlock(), _createBlock(_component_kanban, {
                        key: 0,
                        style: {"height":"calc(100vh - 270px)"},
                        switchListagem: true,
                        titulo: '',
                        editavel: true,
                        colunas: _ctx.state.colunas,
                        "onUpdate:colunas": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.colunas) = $event)),
                        visualizacaoKanban: _ctx.state.visualizarKanban,
                        "onUpdate:visualizacaoKanban": [
                          _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.visualizarKanban) = $event)),
                          _ctx.buscarOps
                        ],
                        onClickVisualizar: _ctx.clickEditar,
                        onClickSubMenu: _ctx.clickSubMenu,
                        onColunaCardAlterada: _ctx.moverCard,
                        onSelecaoCardAlterada: _ctx.selecionarCard,
                        onQtdSelecaoAlterada: _ctx.atualizarSelecionados,
                        onOrdemCardsAlterada: _ctx.atualizarOrdemCards,
                        onClickNovaColuna: _ctx.abrirCriacaoEtapa,
                        onClickEditarColuna: _ctx.abrirEdicaoEtapa,
                        onClickExcluirColuna: _ctx.excluirEtapa
                      }, {
                        menus: _withCtx(() => [
                          _createVNode(_component_a_menu_item, null, {
                            default: _withCtx(() => [
                              _createElementVNode("a", {
                                onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.clickEditar && _ctx.clickEditar(...args)))
                              }, "Visualizar")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["colunas", "visualizacaoKanban", "onClickVisualizar", "onClickSubMenu", "onColunaCardAlterada", "onSelecaoCardAlterada", "onQtdSelecaoAlterada", "onOrdemCardsAlterada", "onClickNovaColuna", "onClickEditarColuna", "onClickExcluirColuna", "onUpdate:visualizacaoKanban"]))
                    : (_openBlock(), _createBlock(_component_processo_producao_listagem, {
                        key: 1,
                        ops: _ctx.state.ops,
                        "onUpdate:ops": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.state.ops) = $event)),
                        paginacao: _ctx.state.paginacao,
                        "onUpdate:paginacao": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.state.paginacao) = $event)),
                        visualizacaoKanban: _ctx.state.visualizarKanban,
                        "onUpdate:visualizacaoKanban": [
                          _cache[15] || (_cache[15] = ($event: any) => ((_ctx.state.visualizarKanban) = $event)),
                          _ctx.buscarOps
                        ],
                        selecionados: _ctx.state.selecionados,
                        "onUpdate:selecionados": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.state.selecionados) = $event)),
                        onVisualizar: _ctx.editarOp,
                        onNovoLancamento: _ctx.incluirOp,
                        onBuscarRecebimentos: _ctx.buscarOps,
                        onSelecaoAlterada: _ctx.atualizarTodosSelecionados,
                        onImprimir: _ctx.imprimir
                      }, null, 8, ["ops", "paginacao", "visualizacaoKanban", "selecionados", "onVisualizar", "onNovoLancamento", "onBuscarRecebimentos", "onSelecaoAlterada", "onUpdate:visualizacaoKanban", "onImprimir"]))
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["spinning"]),
        _createVNode(_component_ordem_producao_modal, {
          operacao: _ctx.state.operacaoLancamento,
          visivel: _ctx.state.exibirLancamento,
          "onUpdate:visivel": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.state.exibirLancamento) = $event)),
          onConfirmacao: _ctx.buscarOps
        }, null, 8, ["operacao", "visivel", "onConfirmacao"]),
        _createVNode(_component_etapa_processo_producao_modal, {
          empresa: _ctx.state.empresaSelecionada,
          processo: _ctx.state.processo.codigo,
          visivel: _ctx.state.exibirAlteracaoColuna,
          "onUpdate:visivel": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.state.exibirAlteracaoColuna) = $event)),
          etapa: _ctx.state.etapaSelecionada,
          onConfirmacao: _ctx.obterProcesso
        }, null, 8, ["empresa", "processo", "visivel", "etapa", "onConfirmacao"]),
        _createVNode(_component_preview_pdf, {
          arquivos: _ctx.state.arquivosPdf
        }, null, 8, ["arquivos"])
      ])
    ])
  ]))
}